/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsMessageResponse } from "../../entities/models/MessageResponse";
import { z } from "zod/v4";

export const modelsMessageResponseSchema = z.object({
    "message": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsMessageResponse>